// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Json from "../../../../../../node_modules/@glennsl/bs-json/src/Json.bs.js";
import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as Config from "../../../../../Config.bs.js";
import * as CountryConfig from "../../../../../library/data-source/country-config/app/entity/CountryConfig.bs.js";
import * as ApiUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as CustomerRepoConfig from "./CustomerRepoConfig.bs.js";
import * as NetworkV2$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/NetworkV2.bs.js";
import * as VerifyEmailPayloadApiModel from "../api-model/VerifyEmailPayloadApiModel.bs.js";
import * as UpdateCustomerPayloadMapper from "../entity-mapper/UpdateCustomerPayloadMapper.bs.js";
import * as UpdateWalletBalanceApiModel from "../api-model/UpdateWalletBalanceApiModel.bs.js";
import * as UpdateCustomerConsentsPayload from "../api-model/UpdateCustomerConsentsPayload.bs.js";
import * as UpdateCustomerPayloadApiModel from "../api-model/UpdateCustomerPayloadApiModel.bs.js";
import * as UpdateWalletBalancePayloadMapper from "../entity-mapper/UpdateWalletBalancePayloadMapper.bs.js";

var fetchCustomerPath = "/crm/customer/summary";

var updateCustomerPath = "/crm/customer/update_details";

var fetchTransactionHistoryPath = "/crm/customer/wallet/transactions";

var fetchCustomerOrderPath = "/crm/customer/order/details";

var addSecondaryNumberpath = "/crm/customer/primary_caller/add_secondary_request_otp_v2.json";

var resendOTPPath = "/crm/customer/primary_caller/add_secondary_resend_otp_v2.json";

var verifyOtpPath = "/crm/customer/primary_caller/add_secondary_verify_otp_v2.json";

var verifyEmailPath = "/administrators/send_customer_email_verification_link";

var sendPaymentLinkPath = "/crm/customer/payment_link_customer";

var updateWalletBalancePath = "/crm/customer/update_wallet_balance";

var fetchCashbackPath = "/crm/customer/cashback_info";

var fetchCustomerConsentsPath = "/crm/customer/consents/status";

var updateCustomerConsentsPath = "/crm/customer/consents/update";

function fetchCustomer(mobile, country) {
  var requestUrl = Config.Env.getCrmGatewayUrl(undefined) + fetchCustomerPath + ("?mobile=" + mobile);
  return NetworkV2$Catalyst.get(requestUrl, {
                country: CountryConfig.countryToString(country)
              }, undefined, undefined, /* Include */2, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(CustomerRepoConfig.CustomerResponseConverter.execute, result);
                        });
            });
}

function updateCustomer(data, formData, country) {
  var payload = Json.stringify(UpdateCustomerPayloadApiModel.t_encode(UpdateCustomerPayloadMapper.execute(data, formData)));
  var requestUrl = Config.Env.getCrmGatewayUrl(undefined) + updateCustomerPath;
  return NetworkV2$Catalyst.post(requestUrl, {
                country: CountryConfig.countryToString(country)
              }, payload, undefined, /* Include */2, undefined, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(CustomerRepoConfig.CustomerResponseConverter.execute, result);
                        });
            });
}

function fetchTransationHistory(uuid, page_size, last_date_timestamp, country) {
  var requestUrl = Config.Env.getCrmGatewayUrl(undefined) + fetchTransactionHistoryPath + ("?customer_uuid=" + uuid + "&page_size=" + String(page_size) + (
      last_date_timestamp !== undefined ? "&last_date_timestamp=" + last_date_timestamp : ""
    ));
  return NetworkV2$Catalyst.get(requestUrl, {
                country: CountryConfig.countryToString(country)
              }, undefined, undefined, /* Include */2, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(CustomerRepoConfig.TransactionHistoryResponseConverter.execute, result);
                        });
            });
}

function fetchCustomerOrder(uuid, page_size, last_date_timestamp, country) {
  var requestUrl = Config.Env.getCrmGatewayUrl(undefined) + fetchCustomerOrderPath + ("?customer_uuid=" + uuid + "&page_size=" + String(page_size) + (
      last_date_timestamp !== undefined ? "&last_date_timestamp=" + last_date_timestamp : ""
    ));
  return NetworkV2$Catalyst.get(requestUrl, {
                country: CountryConfig.countryToString(country)
              }, undefined, undefined, /* Include */2, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(CustomerRepoConfig.CustomerOrderResponseConverter.execute, result);
                        });
            });
}

function addSecondaryNumber(customer_id, mobile, caller_number, country) {
  var requestUrl = Config.Env.getHostName(undefined) + addSecondaryNumberpath + ("?customer_id=" + customer_id + "&new_secondary_number=" + mobile + "&caller_number=" + caller_number);
  return NetworkV2$Catalyst.get(requestUrl, {
                country: CountryConfig.countryToString(country)
              }, undefined, undefined, /* Include */2, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(CustomerRepoConfig.AddSecondaryNumberResponseConverter.execute, result);
                        });
            });
}

function resendOTP(customer_id, request_id, caller_number, country) {
  var requestUrl = Config.Env.getHostName(undefined) + resendOTPPath + ("?customer_id=" + customer_id + "&request_id=" + String(request_id) + "&caller_number=" + caller_number);
  return NetworkV2$Catalyst.get(requestUrl, {
                country: CountryConfig.countryToString(country)
              }, undefined, undefined, /* Include */2, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(CustomerRepoConfig.ResendOTPResponseConverter.execute, result);
                        });
            });
}

function verifyOtp(customer_id, otp, request_id, caller_number, country) {
  var requestUrl = Config.Env.getHostName(undefined) + verifyOtpPath + ("?customer_id=" + customer_id + "&otp=" + String(otp) + "&request_id=" + String(request_id) + "&caller_number=" + caller_number);
  return NetworkV2$Catalyst.get(requestUrl, {
                country: CountryConfig.countryToString(country)
              }, undefined, undefined, /* Include */2, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(CustomerRepoConfig.VerifyOtpResponseConverter.execute, result);
                        });
            });
}

function verifyEmail(customer_id, country) {
  var requestUrl = Config.Env.getHostName(undefined) + verifyEmailPath;
  var payload = Json.stringify(VerifyEmailPayloadApiModel.t_encode({
            customer_id: customer_id
          }));
  return NetworkV2$Catalyst.post(requestUrl, {
                country: CountryConfig.countryToString(country)
              }, payload, undefined, /* Include */2, undefined, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(CustomerRepoConfig.VerifyEmailResponseConverter.execute, result);
                        });
            });
}

function sendPaymentLink(customer_id, amount, country) {
  var requestUrl = Config.Env.getHostName(undefined) + sendPaymentLinkPath + ("?customer_id=" + customer_id + "&amount=" + amount);
  return NetworkV2$Catalyst.get(requestUrl, {
                country: CountryConfig.countryToString(country)
              }, undefined, undefined, /* Include */2, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(CustomerRepoConfig.SendPaymentRequestResponseConverter.execute, result);
                        });
            });
}

function updateWalletBalance(customer_id, wallet_balance, update_amount, updated_at, country) {
  var payload = Json.stringify(UpdateWalletBalanceApiModel.t_encode(UpdateWalletBalancePayloadMapper.execute(customer_id, wallet_balance, update_amount, updated_at)));
  var requestUrl = Config.Env.getCrmGatewayUrl(undefined) + updateWalletBalancePath;
  return NetworkV2$Catalyst.post(requestUrl, {
                country: CountryConfig.countryToString(country)
              }, payload, undefined, /* Include */2, undefined, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(CustomerRepoConfig.UpdateWalletBalanceResponseConverter.execute, result);
                        });
            });
}

function fetchCashback(customer_id, country) {
  var requestUrl = Config.Env.getCrmGatewayUrl(undefined) + fetchCashbackPath + ("?customer_id=" + customer_id);
  return NetworkV2$Catalyst.get(requestUrl, {
                country: CountryConfig.countryToString(country)
              }, undefined, 3, /* Include */2, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(CustomerRepoConfig.CashbackResponseConverter.execute, result);
                        });
            });
}

function fetchPorterGoldDetails(customer_id, country) {
  var requestUrl = Config.Env.getCrmGatewayUrl(undefined) + "/crm/customer/porter_gold_string" + ("?customer_id=" + customer_id);
  return NetworkV2$Catalyst.get(requestUrl, {
                country: CountryConfig.countryToString(country)
              }, undefined, 3, /* Include */2, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(CustomerRepoConfig.PorterGoldDetailsResponseConverter.execute, result);
                        });
            });
}

function fetchCustomerConsents(uuid, country) {
  var requestUrl = Config.Env.getCrmGatewayUrl(undefined) + fetchCustomerConsentsPath + ("?customer_uuid=" + uuid);
  return NetworkV2$Catalyst.get(requestUrl, {
                country: CountryConfig.countryToString(country)
              }, undefined, undefined, /* Include */2, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(CustomerRepoConfig.CustomerConsentsResponseConverter.execute, result);
                        });
            });
}

function updateCustomerConsents(payload, country) {
  var requestUrl = Config.Env.getCrmGatewayUrl(undefined) + updateCustomerConsentsPath;
  var payload$1 = JSON.stringify(UpdateCustomerConsentsPayload.t_encode(payload));
  return NetworkV2$Catalyst.post(requestUrl, {
                country: CountryConfig.countryToString(country)
              }, payload$1, undefined, /* Include */2, undefined, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(CustomerRepoConfig.UpdateCustomerConsentsResponseConverter.execute, result);
                        });
            });
}

var CustomerRepo = {
  fetchCustomerPath: fetchCustomerPath,
  updateCustomerPath: updateCustomerPath,
  fetchTransactionHistoryPath: fetchTransactionHistoryPath,
  fetchCustomerOrderPath: fetchCustomerOrderPath,
  addSecondaryNumberpath: addSecondaryNumberpath,
  resendOTPPath: resendOTPPath,
  verifyOtpPath: verifyOtpPath,
  verifyEmailPath: verifyEmailPath,
  sendPaymentLinkPath: sendPaymentLinkPath,
  updateWalletBalancePath: updateWalletBalancePath,
  fetchCashbackPath: fetchCashbackPath,
  fetchCustomerConsentsPath: fetchCustomerConsentsPath,
  updateCustomerConsentsPath: updateCustomerConsentsPath,
  fetchCustomer: fetchCustomer,
  updateCustomer: updateCustomer,
  fetchTransationHistory: fetchTransationHistory,
  fetchCustomerOrder: fetchCustomerOrder,
  addSecondaryNumber: addSecondaryNumber,
  resendOTP: resendOTP,
  verifyOtp: verifyOtp,
  verifyEmail: verifyEmail,
  sendPaymentLink: sendPaymentLink,
  updateWalletBalance: updateWalletBalance,
  fetchCashback: fetchCashback,
  fetchPorterGoldDetails: fetchPorterGoldDetails,
  fetchCustomerConsents: fetchCustomerConsents,
  updateCustomerConsents: updateCustomerConsents
};

export {
  CustomerRepo ,
  
}
/* Config Not a pure module */
